import React from "react";
import Footer from "../Footer/Footer";

const CancellationReschedule = () => {
  return (
    <>
      <div className="privacy-policy-container">
        <div className="privacy-policy-content">
          <h1 className="title">ORDER CANCELLATION AND RESCHEDULE POLICY</h1>
          <strong>Effective Date: 15th January 2024</strong>
          <p>
            These terms and conditions govern Delightful Gourmet Private Get
            Trendy Order Cancellation and Reschedule Policy. Any Capitalized
            terms used but not defined herein shall have the meaning assigned to
            them under the Terms of Service which govern your use of our website
            www.Get Trendy.in (the “Website”) and our Get Trendy application for
            mobile and handheld devices (the “App”). The Website and the App are
            jointly referred to as the “Platform”. By placing an order with Get
            Trendy, the Customer (“You”/”User”) agrees to abide by the terms and
            conditions outlined in this Order Cancellation and Reschedule
            Policy.
          </p>
          <strong>Cancellation of Orders</strong>
          <p>
            Users placing scheduled orders may choose to cancel their Orders
            free of charge, provided the cancellation is made a minimum of "2
            hours" before the scheduled slot start time. Cancellation requests
            received after this specified time window will result in a
            cancellation fee of upto 100% (one hundred percent) of the order
            value.
          </p>
          <p>
            Users placing express orders may choose to cancel their Orders free
            of charge within "5 minutes" after the order placement. Any
            cancellation requests made after this specified time window will
            result in a cancellation fee of upto 100% (one hundred percent) of
            the order value.
          </p>
          <p>
            However, subject to the User's previous cancellation history or on
            the basis of misuse of this Policy or any other Policy, Get Trendy
            reserves the right to suspend, terminate and/or cancel the order
            placed by the User without reason and may charge a penalty of upto
            100% of the order value and take any other necessary action not
            limited to initiating legal action against the User.
          </p>
          <p>
            For "Pay Online on Delivery" (POD) orders, Get Trendy reserves the
            right to recover the cancellation fee of upto 100% (one hundred
            percent) of the order value from the User in the subsequent order.
          </p>
          <p>
            Get Trendy reserves the right to collect a penalty of upto 100% (one
            hundred percent) of the order value for the Orders constrained to be
            cancelled for reasons not attributable to Get Trendy, including but
            not limited to
          </p>
          <ul>
            <li>
              In the event if the address provided by the User is either wrong
              or falls outside the delivery zone;
            </li>
            <li>
              Failure to contact User by phone at the time of delivering the
              Order booking;
            </li>
            <li>
              Failure to deliver Order due to lack of information, direction or
              authorization from User at the time of delivery
            </li>
          </ul>
          <p>
            In case of cancellations for the reasons attributable to Get Trendy
            shall not collect any penalty from the User.
          </p>
          <strong>Reschedule of Orders</strong>
          <p>
            Users placing scheduled orders have the option to reschedule their
            orders under the following conditions:
          </p>
          <ul>
            <li>
              When placing Scheduled Orders as per the slots made available to
              the User by Get Trendy (“Scheduled Order”), Users may choose to
              reschedule their order up to two times, provided the rescheduling
              is done "2 hours" prior to the slot start time. These reschedules
              shall be free of charge.
            </li>
            <li>
              When placing Express Orders as per the Express Delivery slot made
              available to the User by Get Trendy, Users may choose to
              reschedule their order up to one time at any point, prior to being
              delivered. Rescheduling within these conditions is free of charge.
            </li>
          </ul>
          <strong>Amendments</strong>
          <p>
            icious reserves the right to change/amend/add/delete/modify this
            Policy in whole or in part, at any time without assigning any reason
            whatsoever. The User acknowledges that they will not be personally
            advised of any such change/amendment/addition/deletion/modification.
            The User is advised to check for any such
            change/amendment/addition/deletion/modification regularly. The User
            hereby unconditionally agrees to all such
            changes/amendments/additions/deletions/modifications.
          </p>
          <strong>Contact Us</strong>
          <p>
            If you have any questions or require assistance with order
            cancellations or rescheduling, please contact our customer support
            team at 000-000-0000 or Get Trendy.com.
          </p>
          <p>
            By placing an order with Get Trendy, you agree to abide by the terms
            and conditions outlined in this Order Cancellation and Reschedule
            Policy.
          </p>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default CancellationReschedule;
